import orderBy from 'lodash/orderBy'
import { takeLatest, put, select } from 'redux-saga/effects'
import {
  getGameCategory,
  getGameSubCategory,
  getProviders,
  getStudios,
  addFavoriteGame,
  removeFavoriteGame,
  getFavoriteGame,
  getAllGames,
  getTopGames,
  getTopWinners,
  getTopPlayers,
  getHighWinners,
  getLuckyWinners,
  getCurrentWinners,
  getCasinoProvider,
  getCasinoStudio,
  getRecentGames
} from '../../utils/apiCalls'
import {
  getGameSubCategoryStart,
  getGameSubCategorySuccess,
  getGameSubCategoryFailure,
  getGameSearch,
  getFavGameStart,
  getFavGameSuccess,
  getFavGameFailure,
  getGameCategoryStart,
  getGameCategorySuccess,
  getGameCategoryFailure,
  getHomeDataStart,
  getHomeDataSuccess,
  getHomeDataFailure,
  getProvidersStart,
  getProvidersSuccess,
  getProvidersFailure,
  getStudiosStart,
  getStudiosSuccess,
  getStudiosFailure,
  toggleFavoriteStart,
  toggleFavoriteSuccess,
  toggleFavoriteFailure,
  getFilteredGamesStart,
  getFilteredGamesSuccess,
  getFilteredGamesFailure,
  getTopGamesStart,
  getTopGamesSuccess,
  getTopGamesFailure,
  getTopWinnersStart,
  getTopWinnersSuccess,
  getTopWinnersFailure,
  getTopPlayersStart,
  getTopPlayersSuccess,
  getTopPlayersFailure,
  getHighWinnersStart,
  getHighWinnersSuccess,
  getHighWinnersFailure,
  getLuckyWinnersStart,
  getLuckyWinnersSuccess,
  getLuckyWinnersFailure,
  getCurrentWinnersStart,
  getCurrentWinnersSuccess,
  getCurrentWinnersFailure,
  updateRowsFetched,
  getCategoryProviderListStart,
  getCategoryProviderListSuccess,
  getCategoryProviderListFailure,
  getCategoryStudioListStart,
  getCategoryStudioListSuccess,
  getCategoryStudioListFailure,
  getRecentGamesStart,
  getRecentGamesComplete,
  getProvidersByOrderStart,
  getProvidersByOrderFailure,
  getProvidersByOrderSuccess,
  resetGameSearch, setStudiosByOrder
} from '../redux-slices/casinoMenu'
import { showRealPlayer } from '../redux-slices/loader'
import { setIsUserBlock } from '../redux-slices/user'
import { cmsReorder } from '../../utils/constants'
const getFavGames = (state) => state.casinoMenu.favoriteGamesList
const filteredGames = (state) => state.casinoMenu?.filteredGames
const gameSearch = (state) => state.casinoMenu?.gameSearch
const gameCount = (state) => state.casinoMenu?.rowsFetchedCount

export default function * casinoMenuWatcher () {
  yield takeLatest(getGameCategoryStart.type, getGameCategoryWorker)
  yield takeLatest(getGameSubCategoryStart.type, getGameSubCategoryWorker)
  yield takeLatest(getFavGameStart.type, getFavGameWorker)
  yield takeLatest(getHomeDataStart.type, getHomeDataWorker)
  yield takeLatest(getProvidersStart.type, getProvidersWorker)
  yield takeLatest(getProvidersByOrderStart.type, getProvidersOrderByWorker)
  yield takeLatest(getStudiosStart.type, getStudiosWorker)
  yield takeLatest(toggleFavoriteStart.type, toggleFavoriteWorker)
  yield takeLatest(getFilteredGamesStart.type, getFilteredGamesWorker)
  yield takeLatest(getTopGamesStart.type, getTopGamesWorker)
  yield takeLatest(getTopWinnersStart.type, getTopWinnersWorker)
  yield takeLatest(getTopPlayersStart.type, getTopPlayersWorker)
  yield takeLatest(getHighWinnersStart.type, getHighWinnersWorker)
  yield takeLatest(getLuckyWinnersStart.type, getLuckyWinnersWorker)
  yield takeLatest(getCurrentWinnersStart.type, getCurrentWinnersWorker)
  yield takeLatest(getCategoryProviderListStart.type, getCasinoProviderWorker)
  yield takeLatest(getCategoryStudioListStart.type, getCasinoStudioWorker)
  yield takeLatest(getRecentGamesStart.type, getRecentGamesWorker)
}

function * getGameCategoryWorker (action) {
  try {
    const { limit } = (action && action.payload) || {}
    const { data } = yield getGameCategory({ casinoCategoriesLimit: limit })

    yield put(getGameCategorySuccess(data?.data?.casinoCategories?.rows))
  } catch (e) {
    yield put(getGameCategoryFailure(e?.response?.data?.errors[0]?.description))
  }
}

function * getGameSubCategoryWorker (action) {
  try {
    const { categoryId, limit = '', deviceType } = action && action.payload

    const { data } = yield getGameSubCategory({ categoryId, limit, deviceType })

    // Process the response to rename provider names
    const processedResponse = { ...data?.data?.response }

    processedResponse.categoryId = categoryId
    yield put(getGameSubCategorySuccess(processedResponse))
    yield put(showRealPlayer())
  } catch (e) {
    yield put(getGameSubCategoryFailure(e?.response?.data?.errors[0]?.description))
  }
}

function * getFavGameWorker (action) {
  try {
    const game = yield select(getFavGames)
    const { page, limit } = action && action.payload
    const { data } = yield getFavoriteGame({ limit, pageNo: page })

    // Process the response to rename provider names
    const processedFavoriteGames = { ...data?.data?.favoritesGames }

    if (page === 1) {
      yield put(getFavGameSuccess(processedFavoriteGames))
    } else {
      const newData = {
        count: processedFavoriteGames.count,
        rows: [...game?.rows || [], ...processedFavoriteGames.rows]
      }
      yield put(getFavGameSuccess(newData))
    }
  } catch (e) {
    yield put(getFavGameFailure(e?.response?.data?.errors[0]?.description))
  }
}

function * getHomeDataWorker (action) {
  try {
    const { casinoCategoriesLimit } = action && action.payload

    const { data: gameCategory } = yield getGameCategory({ casinoCategoriesLimit })

    let orderedCMS = []
    if (gameCategory?.data?.cmsList?.rows?.length) {
      orderedCMS = gameCategory?.data?.cmsList?.rows?.sort((a, b) => {
        // Extract names from objects
        const nameA = a.slug
        const nameB = b.slug

        // Get values from mapping object, or use defaultValue if name is not found
        const valueA = cmsReorder[nameA] !== undefined ? cmsReorder[nameA] : Infinity
        const valueB = cmsReorder[nameB] !== undefined ? cmsReorder[nameB] : Infinity

        // Compare values
        return valueA - valueB
      })
    }
    yield put(getHomeDataSuccess({
      gameCategory: {
        cmsList:
        {
          ...gameCategory?.data?.cmsList,
          rows: orderedCMS
        },
        ...gameCategory?.data
      }
    }))

    if (gameCategory?.data?.countryBlocked) {
      yield put(setIsUserBlock(true))
    }

    // Refresh providers and studios data
    yield put(getProvidersStart())
    yield put(getStudiosStart())
    yield put(getCategoryStudioListStart())
  } catch (e) {
    // const { navigate } = action?.payload
    // console.log('e?.response')
    // if (e?.response?.data?.errors[0]?.errorCode === 3000) {
    //   navigate && navigate(`/${getItem('language').toLowerCase() || 'en'}/600`)
    // }

    yield put(getHomeDataFailure(e?.response?.data?.errors[0]?.description))
  }
}

function * getProvidersWorker () {
  try {
    const { data } = yield getProviders({ orderBy: 'orderId' })
    const providers = data?.data?.providers
    yield put(getProvidersSuccess(providers))
  } catch (e) {
    yield put(getProvidersFailure(e?.response?.data?.errors[0]?.description))
  }
}

// TODO:- provider order redux state not used anywhere. Deprecate it.
function * getProvidersOrderByWorker (action) {
  try {
    const { data } = yield getProviders({ orderBy: action?.payload?.orderBy })
    const providers = data?.data?.providers
    yield put(getProvidersByOrderSuccess(providers))
  } catch (e) {
    yield put(getProvidersByOrderFailure(e?.response?.data?.errors[0]?.description))
  }
}

function * getStudiosWorker () {
  try {
    const { data } = yield getStudios({ showProviders: true })
    const studios = data?.data?.gameStudios || []
    yield put(getStudiosSuccess(studios))
    yield put(setStudiosByOrder(orderBy(studios, ['name'], ['asc'])))
  } catch (e) {
    yield put(getStudiosFailure(e?.response?.data?.errors[0]?.description))
  }
}

function * toggleFavoriteWorker (action) {
  try {
    const { isFavorite, id, play = false, setGameData, gameData, fromGlobalSearchModal, fromFilteredGames } = action && action.payload
    let favoriteAction

    if (isFavorite) {
      favoriteAction = 'REMOVE'
      yield removeFavoriteGame({ tenantGameId: id })
    } else {
      favoriteAction = 'ADD'
      yield addFavoriteGame({ tenantGameId: id })
      yield put(getFavGameStart({ page: 1, limit: 100 }))
    }

    yield put(toggleFavoriteSuccess({ favoriteAction, id, fromGlobalSearchModal, fromFilteredGames }))

    if (play) {
      setGameData({ ...gameData, isFavorite: !isFavorite })
    }
  } catch (e) {
    yield put(toggleFavoriteFailure(e?.response?.data?.errors[0]?.description))
  }
}

function * getFilteredGamesWorker (action) {
  try {
    const {
      limit = '',
      pageNo = '',
      // id = '',
      search = '',
      rating = [],
      // themes = [],
      provider = [],
      studio = [],
      fetchMore = false,
      gameInputSearch = false,
      deviceType,
      source = '',
      // category,
      subCategoryId
    } = action && action.payload

    if (gameInputSearch && pageNo === 1) {
      yield put(resetGameSearch())
    }

    const ratingAndThemeFilter = {}

    if (rating !== '[]') {
      ratingAndThemeFilter.rating = rating
    }

    const res = yield getAllGames({
      limit,
      pageNo,
      subCategoryId,
      search,
      ...ratingAndThemeFilter,
      provider,
      studios: studio,
      deviceType,
      source
    })

    // Map through game rows and rename providers if present
    // to maintain consistent provider naming across the application
    const gameList = res?.data?.data?.categoryGames?.rows
    const totalCount = res?.data?.data?.categoryGames?.count

    const uniqueGames = { rows: [], count: 0 }

    if (gameList.length > 0) {
      const games = [...new Map(gameList.map((g) => [g.identifier, g])).values()]
      uniqueGames.rows = games
      uniqueGames.count = res?.data?.data?.categoryGames?.count
    }

    const allFilteredGames = yield select(filteredGames)
    const allGameSearch = yield select(gameSearch)
    const prevGamesCount = yield select(gameCount)

    if (fetchMore && !gameInputSearch) {
      yield put(updateRowsFetched(gameList?.length + prevGamesCount))
      yield put(getFilteredGamesSuccess({
        count: allFilteredGames?.count,
        rows: [...new Map([...allFilteredGames?.rows, ...gameList].map((g) => [g.identifier, g])).values()]
      }))
    } else if (gameInputSearch) {
      /**
       * A filtered array of unique game objects derived from the categoryGames data.
       *
       * The `rows` variable is constructed by taking rows of data from the categoryGames property in the API response,
       * removing duplicate entries based on their `identifier` property, and preserving the first occurrence of each unique identifier.
       *
       * @type {Array<Object>} An array of unique game objects with each object representing data from categoryGames rows.
       */
      // Process rows to rename provider
      const processedRows = [...res?.data?.data?.categoryGames?.rows]

      const rows = [...new Map(processedRows.map((g) => [g.identifier, g])).values()]
      /**
       * The total count of combined items.
       *
       * This variable calculates the sum of the length of rows
       * and the `count` property of the `allGameSearch` object if it exists.
       * If `allGameSearch` or its `count` property is not defined,
       * it defaults to 0.
       */
      const count = rows.length + (allGameSearch?.count || 0)
      if (fetchMore) {
        yield put(getGameSearch({ count, totalCount, rows: [...allGameSearch?.rows, ...rows] }))
      } else {
        yield put(getGameSearch({ count, totalCount, rows }))
      }
    } else {
      yield put(updateRowsFetched(gameList.length))
      yield put(getFilteredGamesSuccess(uniqueGames))
    }
  } catch (e) {
    yield put(getFilteredGamesFailure(e?.response?.data?.errors[0]?.description))
  }
}

function * getTopGamesWorker (action) {
  try {
    const { limit } = action && action.payload

    const { data: res } = yield getTopGames({ limit })

    // Map through game rows and handle both provider and studio information
    const processedGameReport = res?.data?.gameReport?.map(game => {
      // Create a new object with both provider and studio info
      return {
        ...game,
        studioName: game.studioDisplayName || game.studioName || game?.providerDisplayName || game.provider // Fallback to provider if studioName not available
      }
    })

    yield put(getTopGamesSuccess(processedGameReport))
  } catch (e) {
    yield put(getTopGamesFailure(e?.response?.data?.errors?.[0]?.description))
  }
}

function * getTopWinnersWorker (action) {
  try {
    const { limit } = action && action.payload
    const { data: res } = yield getTopWinners({ limit })
    yield put(getTopWinnersSuccess(res?.data))
  } catch (e) {
    yield put(getTopWinnersFailure(e?.response?.data?.errors?.[0]?.description))
  }
}

function * getTopPlayersWorker () {
  try {
    const { data: res } = yield getTopPlayers()
    // API returns { message: 'no records' } instead of an array when there are no winners
    yield put(getTopPlayersSuccess(Array.isArray(res?.data) ? res.data : []))
  } catch (e) {
    yield put(getTopPlayersFailure(e?.response?.data?.errors?.[0]?.description))
  }
}

function * getHighWinnersWorker (action) {
  try {
    const { limit } = action && action.payload
    const { data: res } = yield getHighWinners({ limit })
    yield put(getHighWinnersSuccess(res?.data))
  } catch (e) {
    yield put(getHighWinnersFailure(e?.response?.data?.errors?.[0]?.description))
  }
}

function * getLuckyWinnersWorker (action) {
  try {
    const { limit } = action && action.payload
    const { data: res } = yield getLuckyWinners({ limit })
    yield put(getLuckyWinnersSuccess(res?.data))
  } catch (e) {
    yield put(getLuckyWinnersFailure(e?.response?.data?.errors?.[0]?.description))
  }
}

function * getCurrentWinnersWorker (action) {
  try {
    const { limit } = action && action.payload

    const { data: res } = yield getCurrentWinners({ limit })

    yield put(getCurrentWinnersSuccess(res?.data?.currentWinners))
  } catch (e) {
    yield put(getCurrentWinnersFailure(e?.response?.data?.errors[0]?.description))
  }
}

// TODO:- this saga get called in useFilter but state is not used anywhere. Deprecate it.
function * getCasinoProviderWorker (action) {
  try {
    const { category, search } = action && action.payload

    const { data: res } = yield getCasinoProvider({ category, search })

    // Map through game rows and rename providers if present
    // to maintain consistent provider naming across the application
    const providerList = res?.data?.providerList

    yield put(getCategoryProviderListSuccess(providerList))
  } catch (e) {
    yield put(getCategoryProviderListFailure(e?.response?.data?.errors[0]?.description))
  }
}

function * getCasinoStudioWorker (action) {
  try {
    const { category, search } = action && action.payload
    const { data: res } = yield getCasinoStudio({ category, search })
    const studioList = res?.data?.studioList || []
    yield put(getCategoryStudioListSuccess(studioList))
  } catch (e) {
    yield put(getCategoryStudioListFailure(e?.response?.data?.errors[0]?.description))
  }
}

function * getRecentGamesWorker (action) {
  try {
    const { limit } = action && action.payload

    const { data } = yield getRecentGames({ limit })

    // Map through game rows and handle studio information
    const processedGamesPlayed = data?.data?.gamesPlayed?.map(game => {
      return {
        ...game,
        studioName: game.studioDisplayName || game.studioName || game?.providerDisplayName || game.providerName // Fallback to providerName if studioName not available
      }
    })

    yield put(getRecentGamesComplete(processedGamesPlayed))
  } catch (e) {
    yield put(getRecentGamesComplete())
  }
}
